import {
    ADMIN_GET_BASICS_REQUEST,
    ADMIN_GET_BASICS_SUCCESS,
    ADMIN_GET_BASICS_FAILURE,
    ADMIN_GET_CLUBS_REQUEST,
    ADMIN_GET_CLUBS_SUCCESS,
    ADMIN_GET_CLUBS_FAILURE,
    ADMIN_GET_CLUB_REQUEST,
    ADMIN_GET_CLUB_SUCCESS,
    ADMIN_GET_CLUB_FAILURE,
    ADMIN_GET_MEMBERS_REQUEST,
    ADMIN_GET_MEMBERS_SUCCESS,
    ADMIN_GET_MEMBERS_FAILURE,
    ADMIN_GET_MEMBER_REQUEST,
    ADMIN_GET_MEMBER_SUCCESS,
    ADMIN_GET_MEMBER_FAILURE,
    ADMIN_GET_PIGEON_HOLE_REQUEST,
    ADMIN_GET_PIGEON_HOLE_SUCCESS,
    ADMIN_GET_PIGEON_HOLE_FAILURE,
    ADMIN_CREATE_CLUB_REQUEST,
    ADMIN_CREATE_CLUB_SUCCESS,
    ADMIN_CREATE_CLUB_FAILURE,
    ADMIN_UPDATE_CLUB_REQUEST,
    ADMIN_UPDATE_CLUB_SUCCESS,
    ADMIN_UPDATE_CLUB_FAILURE,
    ADMIN_DELETE_CLUB_REQUEST,
    ADMIN_DELETE_CLUB_SUCCESS,
    ADMIN_DELETE_CLUB_FAILURE,
    ADMIN_CREATE_MEMBER_REQUEST,
    ADMIN_CREATE_MEMBER_SUCCESS,
    ADMIN_CREATE_MEMBER_FAILURE,
    ADMIN_UPDATE_MEMBER_REQUEST,
    ADMIN_UPDATE_MEMBER_SUCCESS,
    ADMIN_UPDATE_MEMBER_FAILURE,
    ADMIN_DELETE_MEMBER_REQUEST,
    ADMIN_DELETE_MEMBER_SUCCESS,
    ADMIN_DELETE_MEMBER_FAILURE,
    ADMIN_CREATE_PIGEONHOLE_REQUEST,
    ADMIN_CREATE_PIGEONHOLE_SUCCESS,
    ADMIN_CREATE_PIGEONHOLE_FAILURE,
    ADMIN_UPDATE_PIGEONHOLE_REQUEST,
    ADMIN_UPDATE_PIGEONHOLE_SUCCESS,
    ADMIN_UPDATE_PIGEONHOLE_FAILURE,
    ADMIN_DELETE_PIGEONHOLE_REQUEST,
    ADMIN_DELETE_PIGEONHOLE_SUCCESS,
    ADMIN_DELETE_PIGEONHOLE_FAILURE,
    ADMIN_CREATE_PIGEON_REQUEST,
    ADMIN_CREATE_PIGEON_SUCCESS,
    ADMIN_CREATE_PIGEON_FAILURE,
    ADMIN_UPDATE_PIGEON_REQUEST,
    ADMIN_UPDATE_PIGEON_SUCCESS,
    ADMIN_UPDATE_PIGEON_FAILURE,
    ADMIN_DELETE_PIGEON_REQUEST,
    ADMIN_DELETE_PIGEON_SUCCESS,
    ADMIN_DELETE_PIGEON_FAILURE,
    ADMIN_CREATE_PIGEONS_REQUEST,
    ADMIN_CREATE_PIGEONS_SUCCESS,
    ADMIN_CREATE_PIGEONS_FAILURE,
    ADMIN_UPDATE_PIGEONS_REQUEST,
    ADMIN_UPDATE_PIGEONS_SUCCESS,
    ADMIN_UPDATE_PIGEONS_FAILURE,
    ADMIN_DELETE_PIGEONS_REQUEST,
    ADMIN_DELETE_PIGEONS_SUCCESS,
    ADMIN_DELETE_PIGEONS_FAILURE,
    ADMIN_CREATE_RINGSERIE_REQUEST,
    ADMIN_CREATE_RINGSERIE_SUCCESS,
    ADMIN_CREATE_RINGSERIE_FAILURE,
    ADMIN_UPDATE_RINGSERIE_REQUEST,
    ADMIN_UPDATE_RINGSERIE_SUCCESS,
    ADMIN_UPDATE_RINGSERIE_FAILURE,
    ADMIN_DELETE_RINGSERIE_REQUEST,
    ADMIN_DELETE_RINGSERIE_SUCCESS,
    ADMIN_DELETE_RINGSERIE_FAILURE,
    ADMIN_GET_SECTIONS_REQUEST,
    ADMIN_GET_SECTIONS_SUCCESS,
    ADMIN_GET_SECTIONS_FAILURE,
    ADMIN_GET_SECTION_REQUEST,
    ADMIN_GET_SECTION_SUCCESS,
    ADMIN_GET_SECTION_FAILURE,
    ADMIN_UPDATE_SECTION_REQUEST,
    ADMIN_UPDATE_SECTION_SUCCESS,
    ADMIN_UPDATE_SECTION_FAILURE,
    ADMIN_CREATE_SECTION_REQUEST,
    ADMIN_CREATE_SECTION_SUCCESS,
    ADMIN_CREATE_SECTION_FAILURE,
    ADMIN_DELETE_SECTION_REQUEST,
    ADMIN_DELETE_SECTION_SUCCESS,
    ADMIN_DELETE_SECTION_FAILURE,
    ADMIN_GET_STATIONS_REQUEST,
    ADMIN_GET_STATIONS_SUCCESS,
    ADMIN_GET_STATIONS_FAILURE,
    ADMIN_GET_STATION_SELECTIONS_REQUEST,
    ADMIN_GET_STATION_SELECTIONS_SUCCESS,
    ADMIN_GET_STATION_SELECTIONS_FAILURE,
    ADMIN_SELECT_STATIONS_REQUEST,
    ADMIN_SELECT_STATIONS_SUCCESS,
    ADMIN_SELECT_STATIONS_FAILURE,
    ADMIN_UNSELECT_STATIONS_REQUEST,
    ADMIN_UNSELECT_STATIONS_SUCCESS,
    ADMIN_UNSELECT_STATIONS_FAILURE,
    ADMIN_CALC_DISTANCES_REQUEST,
    ADMIN_CALC_DISTANCES_SUCCESS,
    ADMIN_CALC_DISTANCES_FAILURE,
    ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST,
    ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS,
    ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE,
    ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST,
    ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS,
    ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE,
    ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST,
    ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS,
    ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE,
    ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST,
    ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS,
    ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS,
    ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE,
    ADMIN_RESET_UPDATE_MARKINGS_REQUEST,
    ADMIN_RESET_UPDATE_MARKINGS_SUCCESS,
    ADMIN_RESET_UPDATE_MARKINGS_FAILURE,
    ADMIN_GET_LIST_ITEMS_REQUEST,
    ADMIN_GET_LIST_ITEMS_SUCCESS,
    ADMIN_GET_LIST_ITEMS_FAILURE,
    ADMIN_CREATE_LIST_ITEM_REQUEST,
    ADMIN_CREATE_LIST_ITEM_SUCCESS,
    ADMIN_CREATE_LIST_ITEM_FAILURE,
    ADMIN_UPDATE_LIST_ITEM_REQUEST,
    ADMIN_UPDATE_LIST_ITEM_SUCCESS,
    ADMIN_UPDATE_LIST_ITEM_FAILURE,
    ADMIN_DELETE_LIST_ITEM_REQUEST,
    ADMIN_DELETE_LIST_ITEM_SUCCESS,
    ADMIN_DELETE_LIST_ITEM_FAILURE,
    ADMIN_EXPORT_RACE_DATE_REQUEST,
    ADMIN_EXPORT_RACE_DATE_SUCCESS,
    ADMIN_EXPORT_RACE_DATE_FAILURE,
    ADMIN_IMPORT_SECTION_STAT_REQUEST,
    ADMIN_IMPORT_SECTION_STAT_SUCCESS,
    ADMIN_IMPORT_SECTION_STAT_FAILURE,
    ADMIN_INVOICE_RACES_REQUEST,
    ADMIN_INVOICE_RACES_SUCCESS,
    ADMIN_INVOICE_RACES_FAILURE,
    ADMIN_START_SEASON_REQUEST,
    ADMIN_START_SEASON_SUCCESS,
    ADMIN_START_SEASON_FAILURE,
    ADMIN_GET_DASHBOARD_REQUEST,
    ADMIN_GET_DASHBOARD_SUCCESS,
    ADMIN_GET_DASHBOARD_FAILURE,
    ADMIN_SELECT_USER_ROLE_REQUEST,
    ADMIN_SELECT_USER_ROLE_SUCCESS,
    ADMIN_SELECT_USER_ROLE_FAILURE,
    ADMIN_SELECT_DATABASE_REQUEST,
    ADMIN_SELECT_DATABASE_SUCCESS,
    ADMIN_SELECT_DATABASE_FAILURE,
    ADMIN_GET_ERROR_LIST_ITEMS_REQUEST,
    ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS,
    ADMIN_GET_ERROR_LIST_ITEMS_FAILURE,
    ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST,
    ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS,
    ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE,
    ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST,
    ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS,
    ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE,
    ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST,
    ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS,
    ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE,
    ADMIN_RELOAD_IMPORT_FILE_REQUEST,
    ADMIN_RELOAD_IMPORT_FILE_SUCCESS,
    ADMIN_RELOAD_IMPORT_FILE_FAILURE,
    ADMIN_GET_GENERAL_REQUEST,
    ADMIN_GET_GENERAL_FAILURE,
    ADMIN_GET_GENERAL_SUCCESS,
    ADMIN_UPDATE_GENERAL_REQUEST,
    ADMIN_UPDATE_GENERAL_SUCCESS,
    ADMIN_UPDATE_GENERAL_FAILURE,
    ADMIN_CREATE_DEPOSIT_REQUEST,
    ADMIN_CREATE_DEPOSIT_SUCCESS,
    ADMIN_CREATE_DEPOSIT_FAILURE,
    ADMIN_UPDATE_DEPOSIT_REQUEST,
    ADMIN_UPDATE_DEPOSIT_SUCCESS,
    ADMIN_UPDATE_DEPOSIT_FAILURE,
    ADMIN_CREATE_MARKING_REQUEST,
    ADMIN_CREATE_MARKING_SUCCESS,
    ADMIN_CREATE_MARKING_FAILURE,
    ADMIN_UPDATE_MARKING_REQUEST,
    ADMIN_UPDATE_MARKING_SUCCESS,
    ADMIN_UPDATE_MARKING_FAILURE,
    ADMIN_GET_SECTION_PRIZE_REQUEST,
    ADMIN_GET_SECTION_PRIZE_SUCCESS,
    ADMIN_GET_SECTION_PRIZE_FAILURE,
    ADMIN_CREATE_SECTION_PRIZE_REQUEST,
    ADMIN_CREATE_SECTION_PRIZE_SUCCESS,
    ADMIN_CREATE_SECTION_PRIZE_FAILURE,
    ADMIN_UPDATE_SECTION_PRIZE_REQUEST,
    ADMIN_UPDATE_SECTION_PRIZE_SUCCESS,
    ADMIN_UPDATE_SECTION_PRIZE_FAILURE,
    ADMIN_DELETE_SECTION_PRIZE_REQUEST,
    ADMIN_DELETE_SECTION_PRIZE_SUCCESS,
    ADMIN_DELETE_SECTION_PRIZE_FAILURE,
    ADMIN_GET_KILOMETERS_REQUEST,
    ADMIN_GET_KILOMETERS_SUCCESS,
    ADMIN_GET_KILOMETERS_FAILURE,
    ADMIN_CREATE_KILOMETER_REQUEST,
    ADMIN_CREATE_KILOMETER_SUCCESS,
    ADMIN_CREATE_KILOMETER_FAILURE,
    ADMIN_UPDATE_KILOMETER_REQUEST,
    ADMIN_UPDATE_KILOMETER_SUCCESS,
    ADMIN_UPDATE_KILOMETER_FAILURE,
    ADMIN_DELETE_KILOMETER_REQUEST,
    ADMIN_DELETE_KILOMETER_SUCCESS,
    ADMIN_DELETE_KILOMETER_FAILURE,
    ADMIN_GET_CHAMPIONSHIPS_REQUEST,
    ADMIN_GET_CHAMPIONSHIPS_SUCCESS,
    ADMIN_GET_CHAMPIONSHIPS_FAILURE,
    ADMIN_GET_CHAMPIONSHIP_REQUEST,
    ADMIN_GET_CHAMPIONSHIP_SUCCESS,
    ADMIN_GET_CHAMPIONSHIP_FAILURE,
    ADMIN_CREATE_CHAMPIONSHIP_REQUEST,
    ADMIN_CREATE_CHAMPIONSHIP_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_FAILURE,
    ADMIN_UPDATE_CHAMPIONSHIP_REQUEST,
    ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_FAILURE,
    ADMIN_DELETE_CHAMPIONSHIP_REQUEST,
    ADMIN_DELETE_CHAMPIONSHIP_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_FAILURE,
    ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST,
    ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE,
    ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST,
    ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE,
    ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST,
    ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE,
    ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST,
    ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE,
    ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST,
    ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE,
    ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST,
    ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE,
    ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST,
    ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
    ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
    ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST,
    ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
    ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
    ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST,
    ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
    ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
    ADMIN_CALC_CHAMPIONSHIPS_REQUEST,
    ADMIN_CALC_CHAMPIONSHIPS_SUCCESS,
    ADMIN_CALC_CHAMPIONSHIPS_FAILURE,
    ADMIN_CALC_SEATS_REQUEST,
    ADMIN_CALC_SEATS_SUCCESS,
    ADMIN_CALC_SEATS_FAILURE,
} from '../constants/actionconstants';
import client from '../utils/ajax/client';
import * as GlobalErrorActions from '../actions/globalerror';
import {confirm} from "../utils/confirmDialog";
import React from "react";

export function getBasics(onSuccess = null) {
    return (dispatch) => {
        dispatch(getBasicsRequest());
        client({
            method: 'GET',
            path: '/api/admin/basics'
        }).then(response => {
            dispatch(getBasicsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning fra databasen", response));
            dispatch(getBasicsFailure(response));
        });
    }
}

function getBasicsRequest() {
    return {
        type : ADMIN_GET_BASICS_REQUEST
    }
}

function getBasicsSuccess(data) {
    return {
        type : ADMIN_GET_BASICS_SUCCESS,
        payload : data
    }
}

function getBasicsFailure(error) {
    return {
        type : ADMIN_GET_BASICS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getClubs(onSuccess = null) {
    return (dispatch) => {
        dispatch(getClubsRequest());
        client({
            method: 'GET',
            path: '/api/admin/clubs'
        }).then(response => {
            dispatch(getClubsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af foreninger fra databasen", response));
            dispatch(getClubsFailure(response));
        });
    }
}

function getClubsRequest() {
    return {
        type : ADMIN_GET_CLUBS_REQUEST
    }
}

function getClubsSuccess(data) {
    return {
        type : ADMIN_GET_CLUBS_SUCCESS,
        payload : data
    }
}

function getClubsFailure(error) {
    return {
        type : ADMIN_GET_CLUBS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getClub(clubNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getClubRequest());
        client({
            method: 'GET',
            path: '/api/admin/club/'+clubNo
        }).then(response => {
            dispatch(getClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af forening fra databasen", response));
            dispatch(getClubFailure(response));
        });
    }
}

function getClubRequest() {
    return {
        type : ADMIN_GET_CLUB_REQUEST
    }
}

function getClubSuccess(data) {
    return {
        type : ADMIN_GET_CLUB_SUCCESS,
        payload : data
    }
}

function getClubFailure(error) {
    return {
        type : ADMIN_GET_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getMembers(onSuccess = null) {
    return (dispatch) => {
        dispatch(getMembersRequest());
        client({
            method: 'GET',
            path: '/api/admin/members'
        }).then(response => {
            dispatch(getMembersSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af medlemmer fra databasen", response));
            dispatch(getMembersFailure(response));
        });
    }
}

function getMembersRequest() {
    return {
        type : ADMIN_GET_MEMBERS_REQUEST
    }
}

function getMembersSuccess(data) {
    return {
        type : ADMIN_GET_MEMBERS_SUCCESS,
        payload : data
    }
}

function getMembersFailure(error) {
    return {
        type : ADMIN_GET_MEMBERS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getMember(memberNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getMemberRequest());
        client({
            method: 'GET',
            path: '/api/admin/member/'+memberNo
        }).then(response => {
            dispatch(getMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af medlem fra databasen", response));
            dispatch(getMemberFailure(response));
        });
    }
}

function getMemberRequest() {
    return {
        type : ADMIN_GET_MEMBER_REQUEST
    }
}

function getMemberSuccess(data) {
    return {
        type : ADMIN_GET_MEMBER_SUCCESS,
        payload : data
    }
}

function getMemberFailure(error) {
    return {
        type : ADMIN_GET_MEMBER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getPigeonHole(clubNo, holeNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getPigeonHoleRequest());
        client({
            method: 'GET',
            path: '/api/admin/pigeon-hole/'+clubNo+'/'+holeNo
        }).then(response => {
            dispatch(getPigeonHoleSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af slag fra databasen", response));
            dispatch(getPigeonHoleFailure(response));
        });
    }
}

function getPigeonHoleRequest() {
    return {
        type : ADMIN_GET_PIGEON_HOLE_REQUEST
    }
}

function getPigeonHoleSuccess(data) {
    return {
        type : ADMIN_GET_PIGEON_HOLE_SUCCESS,
        payload : data
    }
}

function getPigeonHoleFailure(error) {
    return {
        type : ADMIN_GET_PIGEON_HOLE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createClub(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createClubRequest());
        client({
            method: 'POST',
            path: '/api/admin/club',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess(entity.Foreningsnr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af forening", response));
            dispatch(createClubFailure(response));
        });
    }
}

function createClubRequest() {
    return {
        type : ADMIN_CREATE_CLUB_REQUEST
    }
}

function createClubSuccess(entity) {
    return {
        type : ADMIN_CREATE_CLUB_SUCCESS,
        payload : entity
    }
}

function createClubFailure(error) {
    return {
        type : ADMIN_CREATE_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateClub(clubNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateClubRequest());
        client({
            method: 'PUT',
            path: '/api/admin/club/' + clubNo,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            response.entity.originalClubNo = clubNo;
            dispatch(updateClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess(typeof(entity.Foreningsnr ) === "undefined" ? clubNo : entity.Foreningsnr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af forening", response));
            dispatch(updateClubFailure(response));
        });
    }
}

function updateClubRequest() {
    return {
        type : ADMIN_UPDATE_CLUB_REQUEST
    }
}

function updateClubSuccess(entity) {
    return {
        type : ADMIN_UPDATE_CLUB_SUCCESS,
        payload : entity
    }
}

function updateClubFailure(error) {
    return {
        type : ADMIN_UPDATE_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteClub(clubNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteClubRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/club/' + clubNo,
        }).then(response => {
            dispatch(deleteClubSuccess(clubNo));
            if (onSuccess !== null) onSuccess(clubNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af forening", response));
            dispatch(deleteClubFailure(response));
        });
    }
}

function deleteClubRequest() {
    return {
        type : ADMIN_DELETE_CLUB_REQUEST
    }
}

function deleteClubSuccess(clubNo) {
    return {
        type : ADMIN_DELETE_CLUB_SUCCESS,
        payload : clubNo
    }
}

function deleteClubFailure(error) {
    return {
        type : ADMIN_DELETE_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createMember(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createMemberRequest());
        client({
            method: 'POST',
            path: '/api/admin/member',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(entity.Foreningsnr, typeof(entity.Medlemsnr) === 'undefined' ? response.entity.newMemberId : entity.Medlemsnr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af medlem", response));
            dispatch(createMemberFailure(response));
        });
    }
}

function createMemberRequest() {
    return {
        type : ADMIN_CREATE_MEMBER_REQUEST
    }
}

function createMemberSuccess(entity) {
    return {
        type : ADMIN_CREATE_MEMBER_SUCCESS,
        payload : entity
    }
}

function createMemberFailure(error) {
    return {
        type : ADMIN_CREATE_MEMBER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateMember(clubNo, memberNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateMemberRequest());
        client({
            method: 'PUT',
            path: '/api/admin/member/' + clubNo + '/' + memberNo,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(typeof(entity.Foreningsnr) === "undefined" ? clubNo : entity.Foreningsnr, typeof(entity.Medlemsnr) === "undefined" ? memberNo : entity.Medlemsnr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af medlem", response));
            dispatch(updateMemberFailure(response));
        });
    }
}

function updateMemberRequest() {
    return {
        type : ADMIN_UPDATE_MEMBER_REQUEST
    }
}

function updateMemberSuccess(entity) {
    return {
        type : ADMIN_UPDATE_MEMBER_SUCCESS,
        payload : entity
    }
}

function updateMemberFailure(error) {
    return {
        type : ADMIN_UPDATE_MEMBER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteMember(clubNo, memberNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteMemberRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/member/' + clubNo + '/' + memberNo,
        }).then(response => {
            dispatch(deleteMemberSuccess(response.entity));
            if (onSuccess !== null) onSuccess(memberNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af medlem", response));
            dispatch(deleteMemberFailure(response));
        });
    }
}

function deleteMemberRequest() {
    return {
        type : ADMIN_DELETE_MEMBER_REQUEST
    }
}

function deleteMemberSuccess(entity) {
    return {
        type : ADMIN_DELETE_MEMBER_SUCCESS,
        payload : entity
    }
}

function deleteMemberFailure(error) {
    return {
        type : ADMIN_DELETE_MEMBER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createPigeonHole(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createPigeonHoleRequest());
        client({
            method: 'POST',
            path: '/api/admin/pigeonhole',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonHoleSuccess(response.entity));
            if (onSuccess !== null) {
                onSuccess(entity.Foreningsnr, entity.Slagnr);
            }
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af slag", response));
            dispatch(createPigeonHoleFailure(response));
        });
    }
}

function createPigeonHoleRequest() {
    return {
        type : ADMIN_CREATE_PIGEONHOLE_REQUEST
    }
}

function createPigeonHoleSuccess(entity) {
    return {
        type : ADMIN_CREATE_PIGEONHOLE_SUCCESS,
        payload : entity
    }
}

function createPigeonHoleFailure(error) {
    return {
        type : ADMIN_CREATE_PIGEONHOLE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updatePigeonHole(clubNo, holeNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updatePigeonHoleRequest());
        client({
            method: 'PUT',
            path: '/api/admin/pigeonhole/' + clubNo + '/' + holeNo,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updatePigeonHoleSuccess(response.entity));
            if (onSuccess !== null) {
                onSuccess(typeof(entity.Foreningsnr) === "undefined" ? clubNo : entity.Foreningsnr, typeof(entity.Slagnr ) === "undefined" ? holeNo : entity.Slagnr);
            }
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af slag", response));
            dispatch(updatePigeonHoleFailure(response));
        });
    }
}

function updatePigeonHoleRequest() {
    return {
        type : ADMIN_UPDATE_PIGEONHOLE_REQUEST
    }
}

function updatePigeonHoleSuccess(entity) {
    return {
        type : ADMIN_UPDATE_PIGEONHOLE_SUCCESS,
        payload : entity
    }
}

function updatePigeonHoleFailure(error) {
    return {
        type : ADMIN_UPDATE_PIGEONHOLE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deletePigeonHole(clubNo, holeNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deletePigeonHoleRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/pigeonhole/' + clubNo + '/' + holeNo,
        }).then(response => {
            dispatch(deletePigeonHoleSuccess(response.entity));
            if (onSuccess !== null) onSuccess(holeNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af slag", response));
            dispatch(deletePigeonHoleFailure(response));
        });
    }
}

function deletePigeonHoleRequest() {
    return {
        type : ADMIN_DELETE_PIGEONHOLE_REQUEST
    }
}

function deletePigeonHoleSuccess(entity) {
    return {
        type : ADMIN_DELETE_PIGEONHOLE_SUCCESS,
        payload : entity
    }
}

function deletePigeonHoleFailure(error) {
    return {
        type : ADMIN_DELETE_PIGEONHOLE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createPigeon(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createPigeonRequest());
        client({
            method: 'POST',
            path: '/api/admin/pigeon',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            if (response.status.code === 409) {
                confirm("Flyt due til nyt slag", <span>{response.entity.userMessage}</span>, () => {
                    entity.ConfirmWarnings = true;
                    dispatch(createPigeon(entity, onSuccess));
                });
            }
            else dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af due", response));
            dispatch(createPigeonFailure(response));
        });
    }
}

function createPigeonRequest() {
    return {
        type : ADMIN_CREATE_PIGEON_REQUEST
    }
}

function createPigeonSuccess(entity) {
    return {
        type : ADMIN_CREATE_PIGEON_SUCCESS,
        payload : entity
    }
}

function createPigeonFailure(error) {
    return {
        type : ADMIN_CREATE_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updatePigeon(ring, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updatePigeonRequest());
        client({
            method: 'PUT',
            path: '/api/admin/pigeon/' + ring,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af due", response));
            dispatch(updatePigeonFailure(response));
        });
    }
}

function updatePigeonRequest() {
    return {
        type : ADMIN_UPDATE_PIGEON_REQUEST
    }
}

function updatePigeonSuccess(entity) {
    return {
        type : ADMIN_UPDATE_PIGEON_SUCCESS,
        payload : entity
    }
}

function updatePigeonFailure(error) {
    return {
        type : ADMIN_UPDATE_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deletePigeon(ring, onSuccess = null) {
    return (dispatch) => {
        dispatch(deletePigeonRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/pigeon/' + ring,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af due", response));
            dispatch(deletePigeonFailure(response));
        });
    }
}

function deletePigeonRequest() {
    return {
        type : ADMIN_DELETE_PIGEON_REQUEST
    }
}

function deletePigeonSuccess(entity) {
    return {
        type : ADMIN_DELETE_PIGEON_SUCCESS,
        payload : entity
    }
}

function deletePigeonFailure(error) {
    return {
        type : ADMIN_DELETE_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createPigeons(club, pigeonHole, from, to, onSuccess = null) {
    return (dispatch) => {
        dispatch(createPigeonsRequest());
        client({
            method: 'POST',
            path: '/api/admin/create-pigeons/' + club + "/" + pigeonHole + "/" + from + "/" + to,
            entity: {},
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af duer", response));
            dispatch(createPigeonsFailure(response));
        });
    }
}

function createPigeonsRequest() {
    return {
        type : ADMIN_CREATE_PIGEONS_REQUEST
    }
}

function createPigeonsSuccess(entity) {
    return {
        type : ADMIN_CREATE_PIGEONS_SUCCESS,
        payload : entity
    }
}

function createPigeonsFailure(error) {
    return {
        type : ADMIN_CREATE_PIGEONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updatePigeons(club, pigeonHole, input, onSuccess = null) {
    return (dispatch) => {
        dispatch(updatePigeonsRequest());
        client({
            method: 'PUT',
            path: '/api/admin/update-pigeons/' + club + "/" + pigeonHole,
            entity: input,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af duer", response));
            dispatch(updatePigeonsFailure(response));
        });
    }
}

function updatePigeonsRequest() {
    return {
        type : ADMIN_UPDATE_PIGEONS_REQUEST
    }
}

function updatePigeonsSuccess(entity) {
    return {
        type : ADMIN_UPDATE_PIGEONS_SUCCESS,
        payload : entity
    }
}

function updatePigeonsFailure(error) {
    return {
        type : ADMIN_UPDATE_PIGEONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deletePigeons(club, pigeonHole, input, onSuccess = null) {
    return (dispatch) => {
        dispatch(deletePigeonsRequest());
        client({
            method: 'PUT',
            path: '/api/admin/delete-pigeons/' + club + "/" + pigeonHole,
            entity: input,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af due", response));
            dispatch(deletePigeonsFailure(response));
        });
    }
}

function deletePigeonsRequest() {
    return {
        type : ADMIN_DELETE_PIGEONS_REQUEST
    }
}

function deletePigeonsSuccess(entity) {
    return {
        type : ADMIN_DELETE_PIGEONS_SUCCESS,
        payload : entity
    }
}

function deletePigeonsFailure(error) {
    return {
        type : ADMIN_DELETE_PIGEONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createRingSerie(clubNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createRingSerieRequest());
        client({
            method: 'POST',
            path: '/api/admin/ring-serie/' + clubNo,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createRingSerieSuccess({club: clubNo, rings: response.entity}));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af fodringserie", response));
            dispatch(createRingSerieFailure(response));
        });
    }
}

function createRingSerieRequest() {
    return {
        type : ADMIN_CREATE_RINGSERIE_REQUEST
    }
}

function createRingSerieSuccess(entity) {
    return {
        type : ADMIN_CREATE_RINGSERIE_SUCCESS,
        payload : entity
    }
}

function createRingSerieFailure(error) {
    return {
        type : ADMIN_CREATE_RINGSERIE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateRingSerie(clubNo, ringSerieID, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateRingSerieRequest());
        client({
            method: 'PUT',
            path: '/api/admin/ring-serie/' + clubNo + '/' + ringSerieID,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateRingSerieSuccess({club: clubNo, rings: response.entity}));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af fodringserie", response));
            dispatch(updateRingSerieFailure(response));
        });
    }
}

function updateRingSerieRequest() {
    return {
        type : ADMIN_UPDATE_RINGSERIE_REQUEST
    }
}

function updateRingSerieSuccess(entity) {
    return {
        type : ADMIN_UPDATE_RINGSERIE_SUCCESS,
        payload : entity
    }
}

function updateRingSerieFailure(error) {
    return {
        type : ADMIN_UPDATE_RINGSERIE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteRingSerie(clubNo, ringSerieID, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteRingSerieRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/ring-serie/' + clubNo + '/' + ringSerieID,
        }).then(response => {
            dispatch(deleteRingSerieSuccess({club: clubNo, rings: response.entity}));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af fodringserie", response));
            dispatch(deleteRingSerieFailure(response));
        });
    }
}

function deleteRingSerieRequest() {
    return {
        type : ADMIN_DELETE_RINGSERIE_REQUEST
    }
}

function deleteRingSerieSuccess(entity) {
    return {
        type : ADMIN_DELETE_RINGSERIE_SUCCESS,
        payload : entity
    }
}

function deleteRingSerieFailure(error) {
    return {
        type : ADMIN_DELETE_RINGSERIE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getStationSelections(id, onSuccess = null) {
    return (dispatch) => {
        dispatch(getStationSelectionsRequest());
        client({
            method: 'GET',
            path: '/api/admin/station-selections/' + id,
        }).then(response => {
            dispatch(getStationSelectionsSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved indlæsning af stationsvalg fra serveren", response));
            dispatch(getStationSelectionsFailure(response));
        });
    }
}

function getStationSelectionsRequest() {
    return {
        type : ADMIN_GET_STATION_SELECTIONS_REQUEST
    }
}

function getStationSelectionsSuccess(response) {
    return {
        type : ADMIN_GET_STATION_SELECTIONS_SUCCESS,
        payload : response
    }
}

function getStationSelectionsFailure(error) {
    return {
        type : ADMIN_GET_STATION_SELECTIONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function selectStations(id, stations, onSuccess = null) {
    return (dispatch) => {
        dispatch(selectStationsRequest());
        client({
            method: 'PUT',
            path: '/api/admin/station-selections/' + id,
            entity: stations,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(selectStationsSuccess(id, stations));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved overførsel af stationsvalg til serveren", response));
            dispatch(selectStationsFailure(response));
        });
    }
}

function selectStationsRequest() {
    return {
        type : ADMIN_SELECT_STATIONS_REQUEST
    }
}

function selectStationsSuccess(id, stations) {
    return {
        type : ADMIN_SELECT_STATIONS_SUCCESS,
        payload : stations.map(station => ({
            target: id,
            station: station,
        }))
    }
}

function selectStationsFailure(error) {
    return {
        type : ADMIN_SELECT_STATIONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function unselectStations(id, stations, onSuccess = null) {
    return (dispatch) => {
        dispatch(unselectStationsRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/station-selections/' + id,
            entity: stations,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(unselectStationsSuccess(id, stations));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved fjernelse af stationsvalg", response));
            dispatch(unselectStationsFailure(response));
        });
    }
}

function unselectStationsRequest() {
    return {
        type : ADMIN_UNSELECT_STATIONS_REQUEST
    }
}

function unselectStationsSuccess(id, stations) {
    return {
        type : ADMIN_UNSELECT_STATIONS_SUCCESS,
        payload : stations.map(station => ({
            target: id,
            station: station,
        }))
    }
}

function unselectStationsFailure(error) {
    return {
        type : ADMIN_UNSELECT_STATIONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function calculateDistances(id, onSuccess = null) {
    return (dispatch) => {
        dispatch(calculateDistancesRequest());
        client({
            method: 'PUT',
            path: '/api/admin/calc-distances/' + id,
            entity: {},
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(calculateDistancesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af afstande", response));
            dispatch(calculateDistancesFailure(response));
        });
    }
}

function calculateDistancesRequest() {
    return {
        type : ADMIN_CALC_DISTANCES_REQUEST
    }
}

function calculateDistancesSuccess(response) {
    return {
        type : ADMIN_CALC_DISTANCES_SUCCESS,
        payload : response
    }
}

function calculateDistancesFailure(error) {
    return {
        type : ADMIN_CALC_DISTANCES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function setWebPublishing(publicitySelections, onSuccess = null) {
    return (dispatch) => {
        dispatch(setWebPublishingRequest());
        client({
            method: 'PUT',
            path: '/api/admin/set-web-publishing',
            entity: publicitySelections,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(setWebPublishingSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved kopiering af WEB-publiseringsvalg", response));
            dispatch(setWebPublishingFailure(response));
        });
    }
}

function setWebPublishingRequest() {
    return {
        type : ADMIN_SET_WEB_PUBLISHING_FOR_ALL_REQUEST
    }
}

function setWebPublishingSuccess(entity) {
    return {
        type : ADMIN_SET_WEB_PUBLISHING_FOR_ALL_SUCCESS,
        payload : entity
    }
}

function setWebPublishingFailure(error) {
    return {
        type : ADMIN_SET_WEB_PUBLISHING_FOR_ALL_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function setWebPublishingForClub(clubNo, publicitySelections, onSuccess = null) {
    return (dispatch) => {
        dispatch(setWebPublishingForClubRequest());
        client({
            method: 'PUT',
            path: '/api/admin/set-web-publishing/' + clubNo,
            entity: publicitySelections,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(setWebPublishingForClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved kopiering af WEB-publiseringsvalg", response));
            dispatch(setWebPublishingForClubFailure(response));
        });
    }
}

function setWebPublishingForClubRequest() {
    return {
        type : ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_REQUEST
    }
}

function setWebPublishingForClubSuccess(entity) {
    return {
        type : ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_SUCCESS,
        payload : entity
    }
}

function setWebPublishingForClubFailure(error) {
    return {
        type : ADMIN_SET_WEB_PUBLISHING_FOR_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function resetBeginners(onSuccess = null) {
    return (dispatch) => {
        dispatch(resetBeginnersRequest());
        client({
            method: 'PUT',
            path: '/api/admin/reset-beginners',
        }).then(response => {
            dispatch(resetBeginnersSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved nulstilling af begyndere", response));
            dispatch(resetBeginnersFailure(response));
        });
    }
}

function resetBeginnersRequest() {
    return {
        type : ADMIN_RESET_BEGINNER_FOR_ALL_REQUEST
    }
}

function resetBeginnersSuccess(entity) {
    return {
        type : ADMIN_RESET_BEGINNER_FOR_ALL_SUCCESS,
        payload : entity
    }
}

function resetBeginnersFailure(error) {
    return {
        type : ADMIN_RESET_BEGINNER_FOR_ALL_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function resetBeginnersForClub(clubNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(resetBeginnersForClubRequest());
        client({
            method: 'PUT',
            path: '/api/admin/reset-beginners/' + clubNo,
        }).then(response => {
            dispatch(resetBeginnersForClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved nulstilling af begyndere", response));
            dispatch(resetBeginnersForClubFailure(response));
        });
    }
}

function resetBeginnersForClubRequest() {
    return {
        type : ADMIN_RESET_BEGINNER_FOR_CLUB_REQUEST
    }
}

function resetBeginnersForClubSuccess(entity) {
    return {
        type : ADMIN_RESET_BEGINNER_FOR_CLUB_SUCCESS,
        payload : entity
    }
}

function resetBeginnersForClubFailure(error) {
    return {
        type : ADMIN_RESET_BEGINNER_FOR_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function setJuniorPensioner(onSuccess = null) {
    return (dispatch) => {
        dispatch(setJuniorPensionerRequest());
        client({
            method: 'PUT',
            path: '/api/admin/set-junior-pens',
        }).then(response => {
            dispatch(setJuniorPensionerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved markering af juniorer og pensionister", response));
            dispatch(setJuniorPensionerFailure(response));
        });
    }
}

function setJuniorPensionerRequest() {
    return {
        type : ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_REQUEST
    }
}

function setJuniorPensionerSuccess(entity) {
    return {
        type : ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_SUCCESS,
        payload : entity
    }
}

function setJuniorPensionerFailure(error) {
    return {
        type : ADMIN_SET_JUNIOR_PENSIONER_FOR_ALL_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function setJuniorPensionerForClub(clubNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(setJuniorPensionerForClubRequest());
        client({
            method: 'PUT',
            path: '/api/admin/set-junior-pens/' + clubNo,
        }).then(response => {
            dispatch(setJuniorPensionerForClubSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved markering af juniorer og pensionister", response));
            dispatch(setJuniorPensionerForClubFailure(response));
        });
    }
}

function setJuniorPensionerForClubRequest() {
    return {
        type : ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_REQUEST
    }
}

function setJuniorPensionerForClubSuccess(entity) {
    return {
        type : ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_SUCCESS,
        payload : entity
    }
}

function setJuniorPensionerForClubFailure(error) {
    return {
        type : ADMIN_SET_JUNIOR_PENSIONER_FOR_CLUB_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function resetUpdateMarkings(onSuccess = null) {
    return (dispatch) => {
        dispatch(resetUpdateMarkingsRequest());
        client({
            method: 'PUT',
            path: '/api/admin/reset-update-markings',
        }).then(response => {
            dispatch(resetUpdateMarkingsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved nulstilling af adresseændringer og tilmeldinger/afmeldinger", response));
            dispatch(resetUpdateMarkingsFailure(response));
        });
    }
}

function resetUpdateMarkingsRequest() {
    return {
        type : ADMIN_RESET_UPDATE_MARKINGS_REQUEST
    }
}

function resetUpdateMarkingsSuccess(entity) {
    return {
        type : ADMIN_RESET_UPDATE_MARKINGS_SUCCESS,
        payload : entity
    }
}

function resetUpdateMarkingsFailure(error) {
    return {
        type : ADMIN_RESET_UPDATE_MARKINGS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getSections(onSuccess = null) {
    return (dispatch) => {
        dispatch(getSectionsRequest());
        client({
            method: 'GET',
            path: '/api/admin/sections'
        }).then(response => {
            dispatch(getSectionsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af sektioner fra databasen", response));
            dispatch(getSectionsFailure(response));
        });
    }
}

function getSectionsRequest() {
    return {
        type : ADMIN_GET_SECTIONS_REQUEST
    }
}

function getSectionsSuccess(data) {
    return {
        type : ADMIN_GET_SECTIONS_SUCCESS,
        payload : data
    }
}

function getSectionsFailure(error) {
    return {
        type : ADMIN_GET_SECTIONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function getSection(sectionNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getSectionRequest());
        client({
            method: 'GET',
            path: '/api/admin/section/'+sectionNo
        }).then(response => {
            dispatch(getSectionSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            console.log("ERRORTEST", response);
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af sektion fra databasen", response));
            dispatch(getSectionFailure(response));
        });
    }
}

function getSectionRequest() {
    return {
        type : ADMIN_GET_SECTION_REQUEST
    }
}

function getSectionSuccess(data) {
    return {
        type : ADMIN_GET_SECTION_SUCCESS,
        payload : data
    }
}

function getSectionFailure(error) {
    return {
        type : ADMIN_GET_SECTION_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createSection(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createSectionRequest());
        client({
            method: 'POST',
            path: '/api/admin/section',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createSectionSuccess(response.entity));
            if (onSuccess !== null) onSuccess(entity.Sektionsnr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af sektion", response));
            dispatch(createSectionFailure(response));
        });
    }
}

function createSectionRequest() {
    return {
        type : ADMIN_CREATE_SECTION_REQUEST
    }
}

function createSectionSuccess(entity) {
    return {
        type : ADMIN_CREATE_SECTION_SUCCESS,
        payload : entity
    }
}

function createSectionFailure(error) {
    return {
        type : ADMIN_CREATE_SECTION_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateSection(sectionNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateSectionRequest());
        client({
            method: 'PUT',
            path: '/api/admin/section/' + sectionNo,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            response.entity.originalSectionNo = sectionNo;
            dispatch(updateSectionSuccess(response.entity));
            if (onSuccess !== null) onSuccess(typeof(entity.Sektionsnr ) === "undefined" ? sectionNo : entity.Sektionsnr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af sektion", response));
            dispatch(updateSectionFailure(response));
        });
    }
}

function updateSectionRequest() {
    return {
        type : ADMIN_UPDATE_SECTION_REQUEST
    }
}

function updateSectionSuccess(entity) {
    return {
        type : ADMIN_UPDATE_SECTION_SUCCESS,
        payload : entity
    }
}

function updateSectionFailure(error) {
    return {
        type : ADMIN_UPDATE_SECTION_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteSection(sectionNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteSectionRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/section/' + sectionNo,
        }).then(response => {
            dispatch(deleteSectionSuccess(sectionNo));
            if (onSuccess !== null) onSuccess(sectionNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af sektion", response));
            dispatch(deleteSectionFailure(response));
        });
    }
}

function deleteSectionRequest() {
    return {
        type : ADMIN_DELETE_SECTION_REQUEST
    }
}

function deleteSectionSuccess(clubNo) {
    return {
        type : ADMIN_DELETE_SECTION_SUCCESS,
        payload : clubNo
    }
}

function deleteSectionFailure(error) {
    return {
        type : ADMIN_DELETE_SECTION_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getListItems(model, onSuccess = null) {
    return (dispatch) => {
        dispatch(getListItemsRequest());
        client({
            method: 'GET',
            path: '/api/admin/list/' + model
        }).then(response => {
            dispatch(getListItemsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af data fra databasen", response));
            dispatch(getListItemsFailure(response));
        });
    }
}

function getListItemsRequest() {
    return {
        type : ADMIN_GET_LIST_ITEMS_REQUEST
    }
}

function getListItemsSuccess(data) {
    return {
        type : ADMIN_GET_LIST_ITEMS_SUCCESS,
        payload : data
    }
}

function getListItemsFailure(error) {
    return {
        type : ADMIN_GET_LIST_ITEMS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function createListItemItem(model, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createListItemRequest());
        client({
            method: 'POST',
            path: '/api/admin/list/' + model,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.entity[response.entity.key]);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af entitet", response));
            dispatch(createListItemFailure(response));
        });
    }
}

function createListItemRequest() {
    return {
        type : ADMIN_CREATE_LIST_ITEM_REQUEST
    }
}

function createListItemSuccess(entity) {
    return {
        type : ADMIN_CREATE_LIST_ITEM_SUCCESS,
        payload : entity
    }
}

function createListItemFailure(error) {
    return {
        type : ADMIN_CREATE_LIST_ITEM_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateListItem(model, id, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateListItemRequest());
        client({
            method: 'PUT',
            path: '/api/admin/list/' + model + '/' + id,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.entity[response.entity.key]);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af entitet", response));
            dispatch(updateListItemFailure(response));
        });
    }
}

function updateListItemRequest() {
    return {
        type : ADMIN_UPDATE_LIST_ITEM_REQUEST
    }
}

function updateListItemSuccess(entity) {
    return {
        type : ADMIN_UPDATE_LIST_ITEM_SUCCESS,
        payload : entity
    }
}

function updateListItemFailure(error) {
    return {
        type : ADMIN_UPDATE_LIST_ITEM_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteListItem(model, id, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteListItemRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/list/' + model + '/' + id,
        }).then(response => {
            dispatch(deleteListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af entitet", response));
            dispatch(deleteListItemFailure(response));
        });
    }
}

function deleteListItemRequest() {
    return {
        type : ADMIN_DELETE_LIST_ITEM_REQUEST
    }
}

function deleteListItemSuccess(entity) {
    return {
        type : ADMIN_DELETE_LIST_ITEM_SUCCESS,
        payload : entity
    }
}

function deleteListItemFailure(error) {
    return {
        type : ADMIN_DELETE_LIST_ITEM_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function exportRaceData(filters, exportOption, onSuccess = null) {
    return (dispatch) => {
        dispatch(exportRaceDataRequest());
        client({
            method: 'PUT',
            path: '/api/club-program/export-' + exportOption,
            entity: filters,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(exportRaceDataSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved eksport af kapflyvningsdata", response));
            dispatch(exportRaceDataFailure(response));
        });
    }
}

function exportRaceDataRequest() {
    return {
        type : ADMIN_EXPORT_RACE_DATE_REQUEST
    }
}

function exportRaceDataSuccess(entity) {
    return {
        type : ADMIN_EXPORT_RACE_DATE_SUCCESS,
        payload : entity
    }
}

function exportRaceDataFailure(error) {
    return {
        type : ADMIN_EXPORT_RACE_DATE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function importSectionStat(data, onSuccess = null) {
    return (dispatch) => {
        dispatch(importSectionStatRequest());
        client({
            method: 'POST',
            path: '/api/club-program/section-stats',
            entity: data,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(importSectionStatSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved import af sektionsstatistik", response));
            dispatch(importSectionStatFailure(response));
        });
    }
}

function importSectionStatRequest() {
    return {
        type : ADMIN_IMPORT_SECTION_STAT_REQUEST
    }
}

function importSectionStatSuccess(entity) {
    return {
        type : ADMIN_IMPORT_SECTION_STAT_SUCCESS,
        payload : entity
    }
}

function importSectionStatFailure(error) {
    return {
        type : ADMIN_IMPORT_SECTION_STAT_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function invoiceRaces(data, onSuccess = null) {
    return (dispatch) => {
        dispatch(invoiceRacesRequest());
        client({
            method: 'POST',
            path: '/api/admin/invoice-races',
            entity: data,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(invoiceRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved generering af fakturaer", response));
            dispatch(invoiceRacesFailure(response));
        });
    }
}

function invoiceRacesRequest() {
    return {
        type : ADMIN_INVOICE_RACES_REQUEST
    }
}

function invoiceRacesSuccess(entity) {
    return {
        type : ADMIN_INVOICE_RACES_SUCCESS,
        payload : entity
    }
}

function invoiceRacesFailure(error) {
    return {
        type : ADMIN_INVOICE_RACES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function startSeason(options, onSuccess = null) {
    return (dispatch) => {
        dispatch(startSeasonRequest());
        client({
            method: 'POST',
            path: '/api/admin/start-season',
            entity: options,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(startSeasonSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved start af ny sæson", response));
            dispatch(startSeasonFailure(response));
        });
    }
}

function startSeasonRequest() {
    return {
        type : ADMIN_START_SEASON_REQUEST
    }
}

function startSeasonSuccess(entity) {
    return {
        type : ADMIN_START_SEASON_SUCCESS,
        payload : entity
    }
}

function startSeasonFailure(error) {
    return {
        type : ADMIN_START_SEASON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getDashboardData(onSuccess = null) {
    return (dispatch) => {
        dispatch(getDashboardDataRequest());
        client({
            method: 'GET',
            path: '/api/admin/get-dashboard-data',
        }).then(response => {
            dispatch(getDashboardDataSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af dashboard-data", response));
            dispatch(getDashboardDataFailure(response));
        });
    }
}

function getDashboardDataRequest() {
    return {
        type : ADMIN_GET_DASHBOARD_REQUEST
    }
}

function getDashboardDataSuccess(entity) {
    return {
        type : ADMIN_GET_DASHBOARD_SUCCESS,
        payload : entity
    }
}

function getDashboardDataFailure(error) {
    return {
        type : ADMIN_GET_DASHBOARD_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function selectUserRole(role, onSuccess = null) {
    return (dispatch) => {
        dispatch(selectUserRoleRequest());
        client({
            method: 'GET',
            path: '/api/admin/select-user-role/' + role,
        }).then(response => {
            dispatch(selectUserRoleSuccess(role));
            if (onSuccess !== null) onSuccess(role);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved rolleskift", response));
            dispatch(selectUserRoleFailure(response));
        });
    }
}

function selectUserRoleRequest() {
    return {
        type : ADMIN_SELECT_USER_ROLE_REQUEST
    }
}

function selectUserRoleSuccess(entity) {
    return {
        type : ADMIN_SELECT_USER_ROLE_SUCCESS,
        payload : entity
    }
}

function selectUserRoleFailure(error) {
    return {
        type : ADMIN_SELECT_USER_ROLE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function selectDatabase(db, onSuccess = null) {
    return (dispatch) => {
        dispatch(selectDatabaseRequest());
        client({
            method: 'GET',
            path: '/api/admin/select-database/' + db,
        }).then(response => {
            dispatch(selectDatabaseSuccess(db));
            if (onSuccess !== null) onSuccess(db);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved valg af database", response));
            dispatch(selectDatabaseFailure(response));
        });
    }
}

function selectDatabaseRequest() {
    return {
        type : ADMIN_SELECT_DATABASE_REQUEST
    }
}

function selectDatabaseSuccess(entity) {
    return {
        type : ADMIN_SELECT_DATABASE_SUCCESS,
        payload : entity
    }
}

function selectDatabaseFailure(error) {
    return {
        type : ADMIN_SELECT_DATABASE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function getErrorListItems(model, week, club, onSuccess = null) {
    return (dispatch) => {
        dispatch(getErrorListItemsRequest());
        client({
            method: 'GET',
            path: '/api/error-list/' + model + '/' + week + '/' + club
        }).then(response => {
            dispatch(getErrorListItemsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af data fra databasen", response));
            dispatch(getErrorListItemsFailure(response));
        });
    }
}

function getErrorListItemsRequest() {
    return {
        type : ADMIN_GET_ERROR_LIST_ITEMS_REQUEST,
    }
}

function getErrorListItemsSuccess(data) {
    return {
        type : ADMIN_GET_ERROR_LIST_ITEMS_SUCCESS,
        payload : data
    }
}

function getErrorListItemsFailure(error) {
    return {
        type : ADMIN_GET_ERROR_LIST_ITEMS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function updateErrorListItem(model, key, updates, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateErrorListItemRequest());
        client({
            method: 'PUT',
            path: '/api/error-list/update/' + model,
            entity: {
                key: key,
                updates: updates,
            },
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateErrorListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.data);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af fejlentitet", response));
            dispatch(updateErrorListItemFailure(response));
        });
    }
}

function updateErrorListItemRequest() {
    return {
        type : ADMIN_UPDATE_ERROR_LIST_ITEM_REQUEST
    }
}

function updateErrorListItemSuccess(entity) {
    return {
        type : ADMIN_UPDATE_ERROR_LIST_ITEM_SUCCESS,
        payload : entity
    }
}

function updateErrorListItemFailure(error) {
    return {
        type : ADMIN_UPDATE_ERROR_LIST_ITEM_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function deleteErrorListItem(model, keys, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteErrorListItemRequest());
        client({
            method: 'PUT',
            path: '/api/error-list/delete/' + model,
            entity: keys,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(deleteErrorListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af fejlentiteter", response));
            dispatch(deleteErrorListItemFailure(response));
        });
    }
}

function deleteErrorListItemRequest() {
    return {
        type : ADMIN_DELETE_ERROR_LIST_ITEM_REQUEST
    }
}

function deleteErrorListItemSuccess(entities) {
    return {
        type : ADMIN_DELETE_ERROR_LIST_ITEM_SUCCESS,
        payload : entities
    }
}

function deleteErrorListItemFailure(error) {
    return {
        type : ADMIN_DELETE_ERROR_LIST_ITEM_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function acceptErrorListItem(model, keys, onSuccess = null) {
    return (dispatch) => {
        dispatch(acceptErrorListItemRequest());
        client({
            method: 'PUT',
            path: '/api/error-list/accept/' + model,
            entity: keys,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(acceptErrorListItemSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved accept af fejlentiteter", response));
            dispatch(acceptErrorListItemFailure(response));
        });
    }
}

function acceptErrorListItemRequest() {
    return {
        type : ADMIN_ACCEPT_ERROR_LIST_ITEM_REQUEST
    }
}

function acceptErrorListItemSuccess(entities) {
    return {
        type : ADMIN_ACCEPT_ERROR_LIST_ITEM_SUCCESS,
        payload : entities
    }
}

function acceptErrorListItemFailure(error) {
    return {
        type : ADMIN_ACCEPT_ERROR_LIST_ITEM_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function reloadImportFile(fileType, club, week, onSuccess = null, successText = null) {
    return (dispatch) => {
        dispatch(reloadImportFileRequest());
        client({
            method: 'PUT',
            path: '/api/club-program/' + fileType + '/' + club + '/' + week,
            entity: {},
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(reloadImportFileSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity, successText, club, week);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved upload af fil", response));
            dispatch(reloadImportFileFailure(response));
        });
    }
}

function reloadImportFileRequest() {
    return {
        type : ADMIN_RELOAD_IMPORT_FILE_REQUEST
    }
}

function reloadImportFileSuccess(response) {
    return {
        type : ADMIN_RELOAD_IMPORT_FILE_SUCCESS,
        payload : response
    }
}

function reloadImportFileFailure(error) {
    return {
        type : ADMIN_RELOAD_IMPORT_FILE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function getGeneral(onSuccess = null) {
    return (dispatch) => {
        dispatch(getGeneralRequest());
        client({
            method: 'GET',
            path: '/api/admin/general'
        }).then(response => {
            dispatch(getGeneralSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af sektion fra databasen", response));
            dispatch(getGeneralFailure(response));
        });
    }
}

function getGeneralRequest() {
    return {
        type : ADMIN_GET_GENERAL_REQUEST
    }
}

function getGeneralSuccess(data) {
    return {
        type : ADMIN_GET_GENERAL_SUCCESS,
        payload : data
    }
}

function getGeneralFailure(error) {
    return {
        type : ADMIN_GET_GENERAL_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateGeneral(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateGeneralRequest());
        client({
            method: 'PUT',
            path: '/api/admin/general',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateGeneralSuccess(response.entity));
            if (onSuccess !== null) onSuccess('ddb');
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af DDB", response));
            dispatch(updateGeneralFailure(response));
        });
    }
}

function updateGeneralRequest() {
    return {
        type : ADMIN_UPDATE_GENERAL_REQUEST
    }
}

function updateGeneralSuccess(entity) {
    return {
        type : ADMIN_UPDATE_GENERAL_SUCCESS,
        payload : entity
    }
}

function updateGeneralFailure(error) {
    return {
        type : ADMIN_UPDATE_GENERAL_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createDeposit(id, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createDepositRequest());
        client({
            method: 'POST',
            path: `/api/admin/deposit/${id}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createDepositSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af indskud", response));
            dispatch(createDepositFailure(response));
        });
    }
}

function createDepositRequest() {
    return {
        type : ADMIN_CREATE_DEPOSIT_REQUEST
    }
}

function createDepositSuccess(entity) {
    return {
        type : ADMIN_CREATE_DEPOSIT_SUCCESS,
        payload : entity
    }
}

function createDepositFailure(error) {
    return {
        type : ADMIN_CREATE_DEPOSIT_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateDeposit(id, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateDepositRequest());
        client({
            method: 'PUT',
            path: `/api/admin/deposit/${id}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateDepositSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af indskud", response));
            dispatch(updateDepositFailure(response));
        });
    }
}

function updateDepositRequest() {
    return {
        type : ADMIN_UPDATE_DEPOSIT_REQUEST
    }
}

function updateDepositSuccess(entity) {
    return {
        type : ADMIN_UPDATE_DEPOSIT_SUCCESS,
        payload : entity
    }
}

function updateDepositFailure(error) {
    return {
        type : ADMIN_UPDATE_DEPOSIT_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createMarking(id, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createMarkingRequest());
        client({
            method: 'POST',
            path: `/api/admin/marking/${id}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createMarkingSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(createMarkingSuccess(response));
        });
    }
}

function createMarkingRequest() {
    return {
        type : ADMIN_CREATE_MARKING_REQUEST
    }
}

function createMarkingSuccess(entity) {
    return {
        type : ADMIN_CREATE_MARKING_SUCCESS,
        payload : entity
    }
}

function createMarkingFailure(error) {
    return {
        type : ADMIN_CREATE_MARKING_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateMarking(id, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateMarkingRequest());
        client({
            method: 'PUT',
            path: `/api/admin/marking/${id}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateMarkingSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af præmie", response));
            dispatch(updateMarkingFailure(response));
        });
    }
}

function updateMarkingRequest() {
    return {
        type : ADMIN_UPDATE_MARKING_REQUEST
    }
}

function updateMarkingSuccess(entity) {
    return {
        type : ADMIN_UPDATE_MARKING_SUCCESS,
        payload : entity
    }
}

function updateMarkingFailure(error) {
    return {
        type : ADMIN_UPDATE_MARKING_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function getSectionPrizes(sectionNo,onSuccess = null) {
    return (dispatch) => {
        dispatch(getSectionPrizesRequest());
        client({
            method: 'GET',
            path: `/api/admin/section-prizes/${sectionNo}`
        }).then(response => {
            dispatch(getSectionPrizesSuccess(response.entity, sectionNo));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af præmier fra databasen", response));
            dispatch(getSectionPrizesFailure(response));
        });
    }
}

function getSectionPrizesRequest() {
    return {
        type : ADMIN_GET_SECTION_PRIZE_REQUEST
    }
}

function getSectionPrizesSuccess(data, id) {
    return {
        type : ADMIN_GET_SECTION_PRIZE_SUCCESS,
        payload : {
            data: data,
            id: id
        }
    }
}

function getSectionPrizesFailure(error) {
    return {
        type : ADMIN_GET_SECTION_PRIZE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createSectionPrize(id, type, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createSectionPrizeRequest());
        client({
            method: 'POST',
            path: `/api/admin/section-prize/${id}/${type}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createSectionPrizeSuccess(response.entity, id));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(createSectionPrizeFailure(response));
        });
    }
}

function createSectionPrizeRequest() {
    return {
        type : ADMIN_CREATE_SECTION_PRIZE_REQUEST
    }
}

function createSectionPrizeSuccess(entity, id) {
    return {
        type : ADMIN_CREATE_SECTION_PRIZE_SUCCESS,
        payload : {
            data: entity,
            id: id
        }
    }
}

function createSectionPrizeFailure(error) {
    return {
        type : ADMIN_CREATE_SECTION_PRIZE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateSectionPrize(id, type, oldSectionNo, oldValue, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateSectionPrizeRequest());
        client({
            method: 'PUT',
            path: `/api/admin/section-prize/${id}/${type}/${oldSectionNo}/${oldValue}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateSectionPrizeSuccess(response.entity, id));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af præmie", response));
            dispatch(updateSectionPrizeFailure(response));
        });
    }
}

function updateSectionPrizeRequest() {
    return {
        type : ADMIN_UPDATE_SECTION_PRIZE_REQUEST
    }
}

function updateSectionPrizeSuccess(entity, id) {
    return {
        type : ADMIN_UPDATE_SECTION_PRIZE_SUCCESS,
        payload : {
            data: entity,
            id: id
        }
    }
}

function updateSectionPrizeFailure(error) {
    return {
        type : ADMIN_UPDATE_SECTION_PRIZE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteSectionPrize(id, type, sectionNo, value, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteSectionPrizeRequest());
        client({
            method: 'DELETE',
            path: `/api/admin/section-prize/${id}/${type}/${sectionNo}/${value}`,
        }).then(response => {
            dispatch(deleteSectionPrizeSuccess(response.entity, id));
            if (onSuccess !== null) onSuccess(sectionNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af sektion", response));
            dispatch(deleteSectionPrizeFailure(response));
        });
    }
}

function deleteSectionPrizeRequest() {
    return {
        type : ADMIN_DELETE_SECTION_PRIZE_REQUEST
    }
}

function deleteSectionPrizeSuccess(entity, id) {
    return {
        type : ADMIN_DELETE_SECTION_PRIZE_SUCCESS,
        payload : {
            data: entity,
            id: id
        }
    }
}

function deleteSectionPrizeFailure(error) {
    return {
        type : ADMIN_DELETE_SECTION_PRIZE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function getKilometers(onSuccess = null) {
    return (dispatch) => {
        dispatch(getKilometersRequest());
        client({
            method: 'GET',
            path: '/api/admin/kilometers'
        }).then(response => {
            dispatch(getKilometersSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af kilometer-tillæg fra databasen", response));
            dispatch(getKilometersFailure(response));
        });
    }
}

function getKilometersRequest() {
    return {
        type : ADMIN_GET_KILOMETERS_REQUEST
    }
}

function getKilometersSuccess(data) {
    return {
        type : ADMIN_GET_KILOMETERS_SUCCESS,
        payload : data
    }
}

function getKilometersFailure(error) {
    return {
        type : ADMIN_GET_KILOMETERS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createKilometer(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createKilometerRequest());
        client({
            method: 'POST',
            path: '/api/admin/kilometer',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createKilometerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af kilometer-tillæg", response));
            dispatch(createKilometerFailure(response));
        });
    }
}

function createKilometerRequest() {
    return {
        type : ADMIN_CREATE_KILOMETER_REQUEST
    }
}

function createKilometerSuccess(data) {
    return {
        type : ADMIN_CREATE_KILOMETER_SUCCESS,
        payload : data
    }
}

function createKilometerFailure(error) {
    return {
        type : ADMIN_CREATE_KILOMETER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateKilometer(oldKM, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateKilometerRequest());
        client({
            method: 'PUT',
            path: `/api/admin/kilometer/${oldKM}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateKilometerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kilometer-tillæg", response));
            dispatch(updateKilometerFailure(response));
        });
    }
}

function updateKilometerRequest() {
    return {
        type : ADMIN_UPDATE_KILOMETER_REQUEST
    }
}

function updateKilometerSuccess(data) {
    return {
        type : ADMIN_UPDATE_KILOMETER_SUCCESS,
        payload : data
    }
}

function updateKilometerFailure(error) {
    return {
        type : ADMIN_UPDATE_KILOMETER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteKilometer(kilometer, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteKilometerRequest());
        client({
            method: 'DELETE',
            path: `/api/admin/kilometer/${kilometer}`,
        }).then(response => {
            dispatch(deleteKilometerSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af kilometer-tillæg", response));
            dispatch(deleteKilometerFailure(response));
        });
    }
}

function deleteKilometerRequest() {
    return {
        type : ADMIN_DELETE_KILOMETER_REQUEST
    }
}

function deleteKilometerSuccess(data) {
    return {
        type : ADMIN_DELETE_KILOMETER_SUCCESS,
        payload : data
    }
}

function deleteKilometerFailure(error) {
    return {
        type : ADMIN_DELETE_KILOMETER_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function getChampionships(onSuccess = null) {
    return (dispatch) => {
        dispatch(getChampionshipsRequest());
        client({
            method: 'GET',
            path: '/api/admin/championships'
        }).then(response => {
            dispatch(getChampionshipsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af mesterskaber fra databasen", response));
            dispatch(getChampionshipsFailure(response));
        });
    }
}

function getChampionshipsRequest() {
    return {
        type : ADMIN_GET_CHAMPIONSHIPS_REQUEST
    }
}

function getChampionshipsSuccess(data) {
    return {
        type : ADMIN_GET_CHAMPIONSHIPS_SUCCESS,
        payload : data
    }
}

function getChampionshipsFailure(error) {
    return {
        type : ADMIN_GET_CHAMPIONSHIPS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function getChampionship(championshipNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(getChampionshipRequest());
        client({
            method: 'GET',
            path: '/api/admin/championship/'+championshipNo
        }).then(response => {
            dispatch(getChampionshipSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved læsning af mesterskab fra databasen", response));
            dispatch(getChampionshipFailure(response));
        });
    }
}

function getChampionshipRequest() {
    return {
        type : ADMIN_GET_CHAMPIONSHIP_REQUEST
    }
}

function getChampionshipSuccess(data) {
    return {
        type : ADMIN_GET_CHAMPIONSHIP_SUCCESS,
        payload : data
    }
}

function getChampionshipFailure(error) {
    return {
        type : ADMIN_GET_CHAMPIONSHIP_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createChampionship(entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createChampionshipRequest());
        client({
            method: 'POST',
            path: '/api/admin/championship',
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createChampionshipSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity.RecNr);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskab", response));
            dispatch(createChampionshipFailure(response));
        });
    }
}

function createChampionshipRequest() {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_REQUEST
    }
}

function createChampionshipSuccess(entity) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_SUCCESS,
        payload : entity
    }
}

function createChampionshipFailure(error) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateChampionship(id, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateChampionshipRequest());
        client({
            method: 'PUT',
            path: `/api/admin/championship/${id}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateChampionshipSuccess(response.entity));
            if (onSuccess !== null) onSuccess(id);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af mesterskab", response));
            dispatch(updateChampionshipFailure(response));
        });
    }
}

function updateChampionshipRequest() {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_REQUEST
    }
}

function updateChampionshipSuccess(entity) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_SUCCESS,
        payload : entity
    }
}

function updateChampionshipFailure(error) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteChampionship(championshipNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteChampionshipRequest());
        client({
            method: 'DELETE',
            path: '/api/admin/championship/' + championshipNo,
        }).then(response => {
            dispatch(deleteChampionshipSuccess(championshipNo));
            if (onSuccess !== null) onSuccess(championshipNo);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af forening", response));
            dispatch(deleteChampionshipFailure(response));
        });
    }
}

function deleteChampionshipRequest() {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_REQUEST
    }
}

function deleteChampionshipSuccess(championshipNo) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_SUCCESS,
        payload : championshipNo
    }
}

function deleteChampionshipFailure(error) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createChampionshipRace(championshipNo, raceNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(createChampionshipRaceRequest());
        client({
            method: 'POST',
            path: `/api/admin/championship-race/${championshipNo}/${raceNo}`,
        }).then(response => {
            dispatch(createChampionshipRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskabskapflyvning", response));
            dispatch(createChampionshipRaceFailure(response));
        });
    }
}

function createChampionshipRaceRequest() {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_RACE_REQUEST
    }
}

function createChampionshipRaceSuccess(entity) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_RACE_SUCCESS,
        payload : entity
    }
}

function createChampionshipRaceFailure(error) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_RACE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateChampionshipRace(championshipNo, raceNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateChampionshipRaceRequest());
        client({
            method: 'PUT',
            path: `/api/admin/championship-race/${championshipNo}/${raceNo}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateChampionshipRaceSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af mesterskabskapflyvning", response));
            dispatch(updateChampionshipRaceFailure(response));
        });
    }
}

function updateChampionshipRaceRequest() {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_RACE_REQUEST
    }
}

function updateChampionshipRaceSuccess(entity) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_RACE_SUCCESS,
        payload : entity
    }
}

function updateChampionshipRaceFailure(error) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_RACE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteChampionshipRace(championshipNo, raceNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteChampionshipRaceRequest());
        client({
            method: 'DELETE',
            path: `/api/admin/championship-race/${championshipNo}/${raceNo}`,
        }).then(response => {
            const entity = {
                championshipNo: championshipNo,
                raceNo: raceNo,
            }
            dispatch(deleteChampionshipRaceSuccess(entity));
            if (onSuccess !== null) onSuccess(entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af mesterskabskapflyvning", response));
            dispatch(deleteChampionshipRaceFailure(response));
        });
    }
}

function deleteChampionshipRaceRequest() {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_RACE_REQUEST
    }
}

function deleteChampionshipRaceSuccess(entity) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_RACE_SUCCESS,
        payload : entity
    }
}

function deleteChampionshipRaceFailure(error) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_RACE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createChampionshipRaces(championshipNo, type, onSuccess = null) {
    return (dispatch) => {
        dispatch(createChampionshipRacesRequest());
        client({
            method: 'POST',
            path: `/api/admin/championship-races/${championshipNo}/${type}`,
        }).then(response => {
            dispatch(createChampionshipRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskabskapflyvning", response));
            dispatch(createChampionshipRacesFailure(response));
        });
    }
}

function createChampionshipRacesRequest() {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_RACES_REQUEST
    }
}

function createChampionshipRacesSuccess(entity) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_RACES_SUCCESS,
        payload : entity
    }
}

function createChampionshipRacesFailure(error) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_RACES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateChampionshipRaces(championshipNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateChampionshipRacesRequest());
        client({
            method: 'PUT',
            path: `/api/admin/championship-races/${championshipNo}`,
        }).then(response => {
            dispatch(updateChampionshipRacesSuccess(response.entity));
            if (onSuccess !== null) onSuccess(response.entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af mesterskabskapflyvning", response));
            dispatch(updateChampionshipRacesFailure(response));
        });
    }
}

function updateChampionshipRacesRequest() {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_RACES_REQUEST
    }
}

function updateChampionshipRacesSuccess(entity) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_RACES_SUCCESS,
        payload : entity
    }
}

function updateChampionshipRacesFailure(error) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_RACES_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createChampionshipPigeon(championshipNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createChampionshipPigeonRequest());
        client({
            method: 'POST',
            path: `/api/admin/championship-pigeon/${championshipNo}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createChampionshipPigeonSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af mesterskabsdue", response));
            dispatch(createChampionshipPigeonFailure(response));
        });
    }
}

function createChampionshipPigeonRequest() {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_PIGEON_REQUEST
    }
}

function createChampionshipPigeonSuccess(entity) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_PIGEON_SUCCESS,
        payload : entity
    }
}

function createChampionshipPigeonFailure(error) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteChampionshipPigeons(championshipNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteChampionshipPigeonsRequest());
        client({
            method: 'DELETE',
            path: `/api/admin/championship-pigeons/${championshipNo}`,
        }).then(response => {
            dispatch(deleteChampionshipPigeonsSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af mesterskabsduer", response));
            dispatch(deleteChampionshipPigeonsFailure(response));
        });
    }
}

function deleteChampionshipPigeonsRequest() {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_REQUEST
    }
}

function deleteChampionshipPigeonsSuccess(entity) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_SUCCESS,
        payload : entity
    }
}

function deleteChampionshipPigeonsFailure(error) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_PIGEONS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteChampionshipPigeon(championshipNo, ringNo, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteChampionshipPigeonRequest());
        client({
            method: 'DELETE',
            path: `/api/admin/championship-pigeon/${championshipNo}/${ringNo}`,
        }).then(response => {
            const entity = {
                championshipNo: championshipNo,
                ringNo: ringNo,
            }
            dispatch(deleteChampionshipPigeonSuccess(entity));
            if (onSuccess !== null) onSuccess(entity);
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af mesterskabsdue", response));
            dispatch(deleteChampionshipPigeonFailure(response));
        });
    }
}

function deleteChampionshipPigeonRequest() {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_PIGEON_REQUEST
    }
}

function deleteChampionshipPigeonSuccess(entity) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_PIGEON_SUCCESS,
        payload : entity
    }
}

function deleteChampionshipPigeonFailure(error) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_PIGEON_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function createChampionshipDistZone(championshipNo, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(createChampionshipDistZoneRequest());
        client({
            method: 'POST',
            path: `/api/admin/championship-dist-zone/${championshipNo}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(createChampionshipDistZoneSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved oprettelse af afstandszone", response));
            dispatch(createChampionshipDistZoneFailure(response));
        });
    }
}

function createChampionshipDistZoneRequest() {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_REQUEST
    }
}

function createChampionshipDistZoneSuccess(entity) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
        payload : entity
    }
}

function createChampionshipDistZoneFailure(error) {
    return {
        type : ADMIN_CREATE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function updateChampionshipDistZone(championshipNo, zone, entity, onSuccess = null) {
    return (dispatch) => {
        dispatch(updateChampionshipDistZoneRequest());
        client({
            method: 'PUT',
            path: `/api/admin/championship-dist-zone/${championshipNo}/${zone}`,
            entity: entity,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(updateChampionshipDistZoneSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved opdatering af afstandszone", response));
            dispatch(updateChampionshipDistZoneFailure(response));
        });
    }
}

function updateChampionshipDistZoneRequest() {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_REQUEST
    }
}

function updateChampionshipDistZoneSuccess(entity) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
        payload : entity
    }
}

function updateChampionshipDistZoneFailure(error) {
    return {
        type : ADMIN_UPDATE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function deleteChampionshipDistZone(championshipNo, zone, onSuccess = null) {
    return (dispatch) => {
        dispatch(deleteChampionshipDistZoneRequest());
        client({
            method: 'DELETE',
            path: `/api/admin/championship-dist-zone/${championshipNo}/${zone}`,
        }).then(response => {
            dispatch(deleteChampionshipDistZoneSuccess(response.entity));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved sletning af afstandszone", response));
            dispatch(deleteChampionshipDistZoneFailure(response));
        });
    }
}

function deleteChampionshipDistZoneRequest() {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_REQUEST
    }
}

function deleteChampionshipDistZoneSuccess(entity) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_SUCCESS,
        payload : entity
    }
}

function deleteChampionshipDistZoneFailure(error) {
    return {
        type : ADMIN_DELETE_CHAMPIONSHIP_DIST_ZONE_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}

export function calcChampionships(championships, onSuccess = null) {
    return (dispatch) => {
        dispatch(calcChampionshipsRequest());
        client({
            method: 'POST',
            path: '/api/admin/calc-championships',
            timeout: 0,
            entity: championships,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(calcChampionshipsSuccess(response));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af mesterskaber", response));
            dispatch(calcChampionshipsFailure(response));
        });
    }
}

function calcChampionshipsRequest() {
    return {
        type : ADMIN_CALC_CHAMPIONSHIPS_REQUEST
    }
}

function calcChampionshipsSuccess(data) {
    return {
        type : ADMIN_CALC_CHAMPIONSHIPS_SUCCESS,
        payload : data
    }
}

function calcChampionshipsFailure(error) {
    return {
        type : ADMIN_CALC_CHAMPIONSHIPS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


export function calcSeats(seats, onSuccess = null) {
    return (dispatch) => {
        dispatch(calcSeatsRequest());
        client({
            method: 'POST',
            path: '/api/admin/calc-seats',
            entity: seats,
            headers: {'Content-Type': 'application/json'}
        }).then(response => {
            dispatch(calcSeatsSuccess({
                AntalMandaterSektioner: seats.seatsForSection,
                AntalMandaterHovedbestyrelse: seats.seatsForMainBoard,
            }));
            if (onSuccess !== null) onSuccess();
        }).catch(response => {
            dispatch(GlobalErrorActions.addGlobalErrorFromResponse("Fejl ved beregning af mandatfordeling", response));
            dispatch(calcSeatsFailure(response));
        });
    }
}

function calcSeatsRequest() {
    return {
        type : ADMIN_CALC_SEATS_REQUEST
    }
}

function calcSeatsSuccess(data) {
    return {
        type : ADMIN_CALC_SEATS_SUCCESS,
        payload : data
    }
}

function calcSeatsFailure(error) {
    return {
        type : ADMIN_CALC_SEATS_FAILURE,
        payload : {
            status : error.status.code,
            statusText : error.entity
        }
    }
}


// WEBPACK FOOTER //
// ./src/client/src/actions/admin.js